import { render, staticRenderFns } from "./RetentionTax.vue?vue&type=template&id=046e637a"
import script from "./RetentionTax.vue?vue&type=script&lang=js"
export * from "./RetentionTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('046e637a')) {
      api.createRecord('046e637a', component.options)
    } else {
      api.reload('046e637a', component.options)
    }
    module.hot.accept("./RetentionTax.vue?vue&type=template&id=046e637a", function () {
      api.rerender('046e637a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/RetentionTax.vue"
export default component.exports